import { CloudOff, Menu, Search, SettingsOverscan } from "@mui/icons-material";
import { AppBar, Box, IconButton, Toolbar, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { UIViewEnum } from "../../common/enums/UIViewEnum";
import { AppSettingsActionTypeEnum, useAppSettings } from "../../contexts/app-context/AppContext";
import { useOfflineDetectContext } from "../../contexts/offline-detect-context/UseOfflineDetectContext";
import { routesByViewID } from "../../routes/routes";
import BreadCrumb from "../bread-crumb/BreadCrumb";
import MobileSearchBar from "../mobile-search-bar/MobileSearchBar";
import UserMessages from "../user-messages/UserMessages";
import AppHeaderActionMenu from "../app-header-action-menu/AppHeaderActionMenu";
import { useEvaluateFeature } from "../../queries/features/UseEvaluateFeature";
import { useQueryNotifications } from "../../queries/UseQueryNotifications";
import { FeatureConstants } from "../../services/features-data-service/Models";

export type AppBarBottomProps = {
    onToggleNavDrawer: () => void;
};

export default function AppBarBottom({ onToggleNavDrawer }: AppBarBottomProps) {

    const [searchOpen, setSearchOpen] = useState(false);
    const [offlineState] = useOfflineDetectContext();
    const { t } = useTranslation();
    const [appSettings, dispatchAppSettings] = useAppSettings();

    const { data: headerAndActionsV2Feature } = useQueryNotifications(useEvaluateFeature)({
        feature: FeatureConstants.HeaderAndActionsV2,
    });

    const headerAndActionsV2 = (headerAndActionsV2Feature ?? false);


    const theme = useTheme();
    const location = useLocation();
    const searchRoute = routesByViewID.get(UIViewEnum.SearchResults);

    // function onMaximizeView() {

    //     dispatchAppSettings({
    //         type: AppSettingsActionTypeEnum.MaximizeContent,
    //         on: !appSettings.maximizeContent
    //     });

    // }

    useEffect(() => {
        if(location.pathname !== searchRoute.fullPath){
            setSearchOpen(false);
        }
    }, [location.pathname, searchRoute.fullPath]);

    return (
        <>
            {!searchOpen &&
                <AppBar position="fixed" color="primary" sx={{ top: 'auto', bottom: 0 }}>
                    <Toolbar>
                        <IconButton color="inherit"
                            aria-label="open drawer"
                            onClick={() => onToggleNavDrawer()}
                        >
                            <Menu />
                        </IconButton>

                        <Box sx={{ flexGrow: 1, overflow: 'hidden', textOverflow: 'ellipsis' }} >
                            {appSettings.maximizeContent && <BreadCrumb />}
                        </Box>

                        {

                            offlineState.offline &&
                            <Box sx={{
                                display: 'flex',
                                marginTop: 'auto',
                                marginBottom: 'auto'
                            }}
                            //className={classes.offlineInfo}
                            >
                                <CloudOff
                                    sx={{
                                        marginRight: theme.spacing(1)
                                    }}
                                    //className={classes.offlineIcon}
                                    fontSize='small' />
                                {t('appHeader.offline')}
                            </Box>
                        }

                        {
                            !offlineState.offline && <IconButton color="inherit"
                                aria-label="Search entire site"
                                onClick={() => setSearchOpen(true)}>
                                <Search />
                            </IconButton>
                        }

                        {headerAndActionsV2 && <AppHeaderActionMenu />}

                        {!offlineState.offline && !appSettings.maximizeContent && <UserMessages />}

                        {/* <IconButton color={appSettings.maximizeContent ? 'secondary' : 'inherit'}
                            onClick={() => onMaximizeView()}>
                            <SettingsOverscan />
                        </IconButton> */}
                    </Toolbar>
                </AppBar>
            }

            {searchOpen &&
                <MobileSearchBar
                    position="fixed"
                    sx={{ top: 'auto', bottom: 0 }}
                    onClose={() => setSearchOpen(false)} />
            }
        </>

    );
}
